import { registerPathname } from './register-pathname'
import { reportAct, decorateReportAct, defineActivity } from './report-act'

export const sensorsActivity = { reportAct, registerPathname, decorateReportAct, defineActivity }
